import React, { useEffect, useState } from "react";
import MenuCard from "./MenuCard";
import { FaPlus } from "react-icons/fa";
import { Link } from 'react-router-dom';

const MenuList = ({ items = [], onAddMenu, view = "grid" }) => {
  const [menuItems, setMenuItems] = useState(items);
  const isStaff = window.location.pathname.includes('/restaurant-staff');
  const addPath = isStaff ? "/restaurant-staff/employee/menu" : "/restaurant/menus/add";

  useEffect(() => {
    setMenuItems(items);
  }, [items]);

  const handleDeleteSuccess = (deletedId) => {
    setMenuItems((prev) =>
      prev
        .filter((item) => item.id !== deletedId)
        .map((item) => ({
          ...item,
          childMenus:
            item.childMenus?.filter((child) => child.id !== deletedId) || [],
        }))
    );
  };

  return (
    <div className={`w-full ${view === "list" ? "overflow-x-auto pb-4 bg-white rounded-xl shadow-sm border border-gray-100" : ""}`}>
      {view === "list" ? (
        <table className="w-full text-left border-collapse whitespace-nowrap min-w-max">
          <thead>
            <tr className="bg-gray-50 border-b border-gray-100 text-xs font-semibold text-gray-500 uppercase tracking-wider">
              <th className="px-6 py-4">Item</th>
              <th className="px-6 py-4">Price / MRP</th>
              <th className="px-6 py-4">Qty</th>
              <th className="px-6 py-4 text-center">Actions</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-100">
            {menuItems.length > 0 ? (
              menuItems.map((menu) => (
                <MenuCard key={menu.id} menu={menu} view={view} onDeleteSuccess={handleDeleteSuccess} />
              ))
            ) : (
              <tr>
                <td colSpan="4" className="px-6 py-8 text-center text-gray-500">
                  <div className="flex flex-col items-center justify-center py-6">
                    <Link to={addPath} className="text-green-600 hover:text-green-700 font-medium flex items-center gap-2">
                      <FaPlus /> Add New Menu
                    </Link>
                  </div>
                </td>
              </tr>
            )}
          </tbody>
        </table>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {menuItems.length > 0 ? (
            menuItems.map((menu) => (
              <MenuCard key={menu.id} menu={menu} view={view} onDeleteSuccess={handleDeleteSuccess} />
            ))
          ) : (
            <div className="col-span-full flex justify-center items-center py-10">
              <Link to={addPath}
                onClick={onAddMenu}
                className="flex flex-col items-center justify-center w-60 h-40 border-2 border-dashed border-gray-300 rounded-2xl hover:border-green-500 hover:bg-green-50 transition-all duration-300 shadow-sm hover:shadow-lg"
              >
                <FaPlus className="text-3xl text-green-600 mb-2" />
                <span className="text-gray-700 font-medium">Add New Menu</span>
              </Link>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default MenuList;
